import { gsap } from "gsap";

export function topMv() {
  const titles = document.querySelectorAll(".c-mv__title");
  const balloon = document.querySelector(".c-mv__item.js-balloon");

  if (!titles.length && !balloon) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (prefersReducedMotion) return;

  const init = () => {
    const tl = gsap.timeline({ delay: 0.1 });

    if (titles.length) {
      tl.fromTo(
        titles,
        {
          scale: 0,
          autoAlpha: 0,
          transformOrigin: "center center",
        },
        {
          scale: 1,
          autoAlpha: 1,
          duration: 0.7,
          ease: "back.out(1.6)",
          stagger: 0.35,
        }
      );
    }

    if (balloon) {
      tl.fromTo(
        balloon,
        { y: -20, autoAlpha: 0 },
        {
          y: 0,
          autoAlpha: 1,
          duration: 0.6,
          ease: "power2.out",
          onComplete: () => {
            gsap.set(balloon, { clearProps: "transform" });
            balloon.classList.add("is-dropped");
          },
        },
        titles.length ? ">" : 0
      );
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
}
